import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
const SharingPersonalInfo = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Sharing Your Personal Information</h3>

      <p>
        We may disclose personal information to service providers and authorized
        users where necessary to operate our website and platform, provide our
        services, process transactions, manage training and workplace safety
        records, and meet our legal obligations. We limit disclosure to what is
        reasonably necessary for the applicable purpose.
      </p>

      <ul>
        <li>
          <strong>Payment Processing:</strong> Payments made through our
          platform are processed by Stripe or another authorized payment
          processor. Payment information necessary to process a transaction is
          provided directly to the applicable payment processor. Yoda Safety
          Services does not store credit card numbers.
        </li>
        <li>
          <strong>Hosting, Storage, and Technology Service Providers:</strong>{' '}
          We use third-party technology providers to host, operate, maintain,
          and support our website and platform. These providers may process or
          store information on our behalf where necessary to provide their
          services. This includes services used for application hosting,
          database infrastructure, file storage, system logging, and related
          technical operations.
        </li>
        <li>
          <strong>File and Document Storage:</strong> We use Amazon Web Services
          (AWS) for cloud storage of certain platform files and documents,
          including certificates, safety forms, safety manuals, and related
          files. Information contained in or associated with these files may
          therefore be stored or processed through AWS.
        </li>
        <li>
          <strong>Email and Communication Services:</strong> We may use
          third-party email service providers, including Brevo, to deliver
          transactional, service-related, newsletter, or promotional
          communications. Information necessary to deliver these communications
          may be processed by the applicable email service provider.
        </li>
        <li>
          <strong>Company and Training Management:</strong> Where your account
          or training is associated with a company or organization, authorized
          company managers or representatives may have access to training
          information associated with users under their company account. This
          may include assigned courses, course progress and completion status,
          quiz or assessment results, training records, and certificates.
        </li>
        <li>
          <strong>Digital Safety Forms and Documentation:</strong> Information
          submitted through digital safety forms may be accessible to the user
          who submitted the entry, authorized company managers, authorized
          platform administrators, and subcontractors who have been specifically
          granted permission to access the applicable forms or records. Access
          is based on account roles and permissions within the platform.
        </li>
        <li>
          <strong>Authorized Platform Administration:</strong> Personal
          information may be accessed by authorized individuals where reasonably
          necessary to operate, maintain, secure, troubleshoot, support, or
          administer the platform and its services. Administrative access is
          restricted to authorized individuals who require that access for these
          purposes.
        </li>
        <li>
          <strong>Legal and Regulatory Requirements:</strong> We may disclose
          personal information where required or permitted by applicable law,
          regulation, court order, legal process, or lawful request, or where
          reasonably necessary to protect the rights, safety, security, or
          property of Yoda Safety Services, our users, or others.
        </li>
        <li>
          <strong>Business Transfers:</strong> If Yoda Safety Services is
          involved in a merger, acquisition, reorganization, financing, sale of
          assets, or similar business transaction, personal information may be
          transferred as part of that transaction, subject to applicable privacy
          requirements.
        </li>
      </ul>

      <p>
        Yoda Safety Services does not sell personal information to third
        parties. We do not disclose personal information to third parties for
        their own marketing purposes without consent where consent is required
        by applicable law.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default SharingPersonalInfo;
